
import { Building, Shield, Smartphone } from 'lucide-react';
import { CardHeaderProps } from './types';
import { TooltipIcon } from './TooltipIcon';

export const CardHeader = ({ displayName, provider }: CardHeaderProps) => {
  return (
    <div className="flex items-center gap-2">
      <Building className="h-5 w-5 text-primary/70" />
      <h3 className="font-semibold text-lg">{displayName}</h3>
      
      {provider.is_esac_accredited && (
        <TooltipIcon 
          icon={<Shield className="h-4 w-4 text-blue-500" />} 
          tooltipText="ESAC Accredited" 
        />
      )}
      
      {provider.mobile_app && (
        <TooltipIcon 
          icon={<Smartphone className="h-4 w-4 text-green-500" />} 
          tooltipText="Mobile App Available" 
        />
      )}
    </div>
  );
};
